// Importing necessary React libraries and components
import React, { useState, useContext, useEffect } from "react";
import {
  Box,
  Typography,
  Button,
  IconButton,
  Menu,
  MenuItem,
  Dialog,
  DialogActions,
  DialogTitle,
  Tab,
  Tabs,
  Popper,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { styled } from "@mui/material/styles";
import { useNavigate } from "react-router-dom";
import BookingTypes from "./bookingType";
import { UserContext } from "../../auth/auth-context";
import { useSelectedBusiness } from "../../../redux/store";
import BookingIframeGenerator from "../../../util/iframe/bookingIframeGenerator";
import { usePermissions } from "../../../hooks/usePermissions";
import { BusinessQueryNames } from "../../../graphql/queries";
import useLoadReduxStoreData from "../../../redux/reducers/loadReduxStoreData";
import { useAuthStatus } from "../../../util/useAuthStatus";

// Custom styled container
const ContentHeader = styled(Box)(({ theme }) => ({
  display: "flex",
  justifyContent: "center",
  height: "90px",
}));

const ContentHead = styled(Box)(({ theme }) => ({
  display: "flex",
  width: "100%",
  flexDirection: "column",
  justifyContent: "space-between",
}));

const Top = styled(Box)(({ theme }) => ({
  display: "flex",
  padding: "30px",
  height: "30%",
  alignItems: "center",
  justifyContent: "space-between",
}));

// Main Home component
const BookingTypeHome = (props) => {
  const userContext = useContext(UserContext);
  const providerUser = userContext.providerUser;

  const selectedBusiness = useSelectedBusiness();
  const businessUrl = selectedBusiness?.businessBasic?.url || "";
  const [isDiabled, setIsDisabled] = useState(false)
  const currentLoginStaff = selectedBusiness?.businessStaffs?.find(
    (staff) => Number(staff.id) === providerUser.staffId
  );
  const { isLoggedIn } = useAuthStatus();

  const { refetch: reloadBusinesses } = useLoadReduxStoreData(
    BusinessQueryNames.GET_MY_BUSINESSES,
    { enabled: isLoggedIn }
  );

  const { canEditBookingType } = usePermissions();

  useEffect(() => {
    const canEdit = canEditBookingType(Number(currentLoginStaff?.id));
    canEdit ? setIsDisabled(false) : setIsDisabled(true)
  }, [canEditBookingType, currentLoginStaff?.id])

  useEffect(() => {
    if (!selectedBusiness) {
      // Reload the business data if not available
      reloadBusinesses();
    }
  }, [selectedBusiness, reloadBusinesses]);


  // Tab value state
  const [value, setValue] = React.useState(0);

  React.useEffect(() => {
    const searchParams = new URLSearchParams(window.location.search);
    const queryParam = searchParams.get("tab");
    if (queryParam) {
      const index = parseInt(queryParam);
      if (!isNaN(index) && index - 1 >= 0 && index - 1 < 2) {
        setValue(index - 1);
      }
    }
  }, []);

  const handleChange = (bookingType, newValue) => {
    setValue(newValue);
    const searchParams = new URLSearchParams(window.location.search);
    if (newValue === 0) {
      searchParams.delete("scheduletab");
    } else if (newValue === 1) {
      searchParams.set("scheduletab", 1);
    }
    searchParams.set("tab", newValue + 1);
    const newUrl = window.location.pathname + "?" + searchParams.toString();
    window.history.pushState(null, null, newUrl);
  };

  const [anchorEl, setAnchorEl] = useState(null);
  const [dialogOpen, setDialogOpen] = useState(false);
  const navigate = useNavigate();

  const handleMenuClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleEmbedClick = () => {
    setDialogOpen(true);
    handleMenuClose();
  };

  const handleDialogClose = () => {
    setDialogOpen(false);
  };

  const handleClick = (event) => {
    setAnchorEl(anchorEl ? null : event.currentTarget);
  };

  const handleLinkClick = (bookingtypecategory) => {
    const formattedPage = bookingtypecategory.toLowerCase();
    const href = `/biz/create/${formattedPage}?back=1`;
    navigate(href);
  };

  return (
    <>
      <ContentHeader>
        <ContentHead>
          <Top>
            <Box sx={{ display: "flex", width: "100%" }}>
              <Box sx={{ flexGrow: 1 }} /> {/* This box will take up remaining space */}
              <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
                <Button
                  disabled={isDiabled}
                  onClick={(e) => {
                    props?.data?.length > 0 && providerUser.plan === "Free"
                      ? handleClick(e)
                      : handleLinkClick("event");
                  }}
                  variant="outlined"
                  startIcon={<AddIcon />}
                >
                  Add Booking Types
                </Button>
                <IconButton onClick={handleMenuClick}>
                  <MoreVertIcon />
                </IconButton>
                <Menu
                  anchorEl={anchorEl}
                  open={Boolean(anchorEl)}
                  onClose={handleMenuClose}                 
                >
                  <MenuItem  disabled={isDiabled}  onClick={handleEmbedClick}>Embed to your page</MenuItem>
                </Menu>
                <Dialog
                  open={dialogOpen}
                  onClose={handleDialogClose}
                  fullWidth
                  maxWidth="sm"
                >
                  <Box sx={{ p: 2 }}>
                    <BookingIframeGenerator businessUrl={businessUrl} />
                  </Box>
                  <DialogActions>
                    <Button onClick={handleDialogClose} variant="outlined">
                      Close
                    </Button>
                  </DialogActions>
                </Dialog>
              </Box>
            </Box>
          </Top>
        </ContentHead>
      </ContentHeader>

      <BookingTypes
        refetch={props.refetch}
        user={providerUser.url}
        data={props.data} 
      />
    </>
  );
};

export default BookingTypeHome;
